import { takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects'; // call, put, select, take
import _ from 'lodash';
import { containsBadWord } from 'module-tes-f__kin-swear-jar';
import createWebAPI from './WebAPI';

const GET_MORE_REVIEWS = 'user-dashboard/reviews/GET_MORE_REVIEWS';
export const getMoreReviews = (options = {}) => ({ type: GET_MORE_REVIEWS, options });

const SET_REVIEWS_LOADED = 'user-dashboard/reviews/SET_REVIEWS_LOADED';
export const setReviewsLoaded = value => ({ type: SET_REVIEWS_LOADED, value });

const SET_REVIEWS_ALL_LOADED = 'user-dashboard/reviews/SET_REVIEWS_ALL_LOADED';
export const setReviewsAllLoaded = value => ({ type: SET_REVIEWS_ALL_LOADED, value });

const LOAD_REVIEWS_PARTIAL_RESULT = 'user-dashboard/reviews/LOAD_REVIEWS_PARTIAL_RESULT';
export const loadReviewsPartialResult = items => ({ type: LOAD_REVIEWS_PARTIAL_RESULT, items });

const RELOAD_REVIEWS = 'user-dashboard/reviews/RELOAD_REVIEWS';
export const reloadReviews = items => ({ type: RELOAD_REVIEWS, items });

const SET_USER_REVIEW = 'user-dashboard/reviews/SET_USER_REVIEW';
export const setUserReview = review => ({ type: SET_USER_REVIEW, review });

const CANCEL_USER_REVIEW = 'user-dashboard/reviews/CANCEL_USER_REVIEW';
export const cancelUserReview = review => ({ type: CANCEL_USER_REVIEW, review });

const SUBMIT_REVIEW = 'user-dashboard/reviews/SUBMIT_REVIEW';
export const submitReview = (params) => ({ type: SUBMIT_REVIEW, params });

const SET_REVIEW_ERROR = 'user-dashboard/reviews/SET_REVIEW_ERROR';
export const setReviewError = error => ({ type: SET_REVIEW_ERROR, error });

const DELETE_REVIEW_ERROR = 'user-dashboard/reviews/DELETE_REVIEW_ERROR';
export const deleteReviewError = error => ({ type: DELETE_REVIEW_ERROR, error });

const SET_FORCED_RESOURCE_COUNT = 'user-dashboard/reviews/SET_FORCED_RESOURCE_COUNT';
export const setForcedResourceCount = value => ({ type: SET_FORCED_RESOURCE_COUNT, value });

const ADD_RECENT_REVIEW = 'user-dashboard/reviews/ADD_RECENT_REVIEW';
export const addRecentReview = (review, index) => ({ type: ADD_RECENT_REVIEW, review, index });

const REMOVE_RECENT_REVIEW = 'user-dashboard/reviews/REMOVE_RECENT_REVIEW';
export const removeRecentReview = resourceId => ({ type: REMOVE_RECENT_REVIEW, resourceId });

const SET_REVIEW_DISPLAY_STATE = 'user-dashboard/reviews/SET_REVIEW_DISPLAY_STATE';
export const setReviewDisplayState = (id, value) => ({ type: SET_REVIEW_DISPLAY_STATE, id, value });

const GET_NUM_OF_COMMENTED_REVIEWS = 'user-dashboard/reviews/GET_NUM_OF_COMMENTED_REVIEWS';
export const getNumOfCommentedReviews = () => ({ type: GET_NUM_OF_COMMENTED_REVIEWS });

const GET_REVIEW_REASONS = 'user-dashboard/reviews/GET_REVIEW_REASONS';
export const getReviewReasons = () => ({ type: GET_REVIEW_REASONS });

const SET_NUM_OF_COMMENTED_REVIEWS = 'user-dashboard/reviews/SET_NUM_OF_COMMENTED_REVIEWS';
export const setNumOfCommentedReviews = numOfCommentedReviews => ({ type: SET_NUM_OF_COMMENTED_REVIEWS, numOfCommentedReviews });

const SET_REVIEW_REASONS = 'user-dashboard/reviews/SET_REVIEW_REASONS';
export const setReviewReasons = reviewReasons => ({ type: SET_REVIEW_REASONS, reviewReasons });

const SET_IS_PROFAN = 'user-dashboard/reviews/SET_IS_PROFAN';
export const setIsProfan = reviewMessage => ({ type: SET_IS_PROFAN, reviewMessage });

const initialState = {
  reviews: [],
  reviewsPagesLoaded: 0,
  reviewsToShow: 10,
  reviewsAllLoaded: false,
  reviewsLoaded: false,
  userReviews: {},
  reviewErrors: {},
  forcedResourceCount: 0,
  reviewDisplayStates: {},
  recentReviews: {},
  numOfCommentedReviews: 0,
  reviewReasons: [],
  isProfan: false,
};

const webApi = createWebAPI();

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REMOVE_RECENT_REVIEW: {
      const { resourceId } = action;
      const currentReviews = { ...state.recentReviews };
      let index;
      Object.keys(currentReviews).forEach(rk => {
        if (resourceId === currentReviews[rk].asset.id) index = rk;
      });
      delete currentReviews[index];
      const newReviews = state.reviews.concat([]);
      newReviews.splice(index, 1);
      return { ...state, recentReviews: currentReviews, reviews: newReviews };
    }
    case SET_REVIEW_DISPLAY_STATE: {
      const { id, value } = action;
      const reviewDisplayStates = { ...state.reviewDisplayStates };
      reviewDisplayStates[id] = value;
      if (!value) delete reviewDisplayStates[id];
      return { ...state, reviewDisplayStates };
    }
    case SET_NUM_OF_COMMENTED_REVIEWS: {
      return { ...state, numOfCommentedReviews: action.numOfCommentedReviews };
    }
    case SET_REVIEW_REASONS: {
      return { ...state, reviewReasons: action.reviewReasons };
    }
    case ADD_RECENT_REVIEW: {
      const { review, index } = action;
      const reviewObject = { ...state.recentReviews };
      Object.keys(reviewObject).forEach(ro => {
        reviewObject[ro].resource.played = true;
      });
      reviewObject[index] = review;
      return { ...state, recentReviews: reviewObject };
    }
    case SET_REVIEWS_LOADED: {
      return { ...state, reviewsLoaded: action.value };
    }
    case SET_REVIEWS_ALL_LOADED: {
      return { ...state, reviewsAllLoaded: action.value };
    }
    case RELOAD_REVIEWS: {
      return { ...state, reviews: [] };
    }
    case LOAD_REVIEWS_PARTIAL_RESULT: {
      if (action.items) {
        return { ...state, reviews: state.reviews.concat(action.items) };
      }
      return { ...state, reviews: state.reviews.concat([]) };
    }
    case SET_USER_REVIEW: {
      const { review } = action;
      const userReviews = { ...state.userReviews };
      const newReview = { ...userReviews[review.id], ...review };
      userReviews[review.id] = newReview;
      return { ...state, userReviews };
    }
    case CANCEL_USER_REVIEW: {
      const { review } = action;
      const userReviews = { ...state.userReviews };
      delete userReviews[review.id];
      return { ...state, userReviews };
    }
    case SET_REVIEW_ERROR: {
      const { error } = action;
      const reviewErrors = { ...state.reviewErrors };
      reviewErrors[error.id] = error.msg;
      return { ...state, reviewErrors };
    }
    case DELETE_REVIEW_ERROR: {
      const { error } = action;
      const reviewErrors = { ...state.reviewErrors };
      delete reviewErrors[error.id];
      return { ...state, reviewErrors };
    }
    case SET_FORCED_RESOURCE_COUNT: {
      return { ...state, forcedResourceCount: action.value };
    }
    case SET_IS_PROFAN: {
      return { ...state, isProfan: containsBadWord(action.reviewMessage) };
    }
    default:
      return state;
  }
}

export function sagas() {
  function* submitReviewsSaga(action) {
    const { review, resource, refreshResources, whenDone } = action.params;
    try {
      const isReviewMessageProfan = yield select(state => state.reviewsModule.isProfan);
      if (isReviewMessageProfan) {
        whenDone(isReviewMessageProfan);
        return;
      }
      const { reviewsToShow, reviews } = yield select((state) => ({
        reviewsToShow: state.reviewsModule.reviewsToShow,
        reviews: state.reviewsModule.reviews,
      }));

      if (review.comment === undefined) {
        review.comment = '';
      }

      yield call(() => webApi.reviews.submitReview(review));
      if (whenDone) whenDone();

      review.resource = resource;

      const resourceIndex = _.findIndex(reviews, (r => r.resource._id === review.asset.id)); // eslint-disable-line no-underscore-dangle

      yield put(addRecentReview(review, resourceIndex));

      if (refreshResources) {
        yield put(setReviewsLoaded(false));
        const reviewsReloaded = yield call(() => webApi.reviews.getUnreviewedResources({ skip: 0, limit: reviews.length }));

        if (reviewsReloaded.length <= 0) yield put(setReviewsAllLoaded(true));

        yield put(reloadReviews());

        const { recentReviews } = yield select((state) => ({ recentReviews: state.reviewsModule.recentReviews }));

        const recents = Object.keys(recentReviews);

        recents.forEach(recent => {
          reviewsReloaded.splice(Number(recent), 0, { resource: recentReviews[recent].resource, review });
        });

        yield put(loadReviewsPartialResult(reviewsReloaded));
        yield put(setReviewsLoaded(true));

        if (reviewsReloaded.length < reviewsToShow) yield put(setReviewsAllLoaded(true));
      }

      yield put(deleteReviewError({ id: review.asset.id }));
    } catch (ex) {
      if (ex.body) {
        yield put(setReviewError({ msg: 'submit review error', id: review.asset.id }));
      }
      // eslint-disable-next-line no-console
      console.error('Exception in submit review saga', ex);
    }
  }

  function* getMoreReviewsSaga(action) {
    try {
      const { reviewsLoaded, reviewsToShow, reviews, reviewsAllLoaded, reviewsKeywordFilter, forcedResourceCount } = yield select((state) => ({
        reviewsLoaded: state.reviewsModule.reviewsLoaded,
        reviewsToShow: state.reviewsModule.reviewsToShow,
        reviews: state.reviewsModule.reviews,
        reviewsAllLoaded: state.reviewsModule.reviewsAllLoaded,
        reviewsKeywordFilter: state.reviewsModule.reviewsKeywordFilter,
        forcedResourceCount: state.reviewsModule.forcedResourceCount,
      }));
      if (reviewsLoaded && reviewsAllLoaded) return;

      const { resourcesOnly, ignoreResources, limit } = action.options;
      const params = {
        skip: reviews.length,
        limit: limit || reviewsToShow,
      };
      if (reviewsKeywordFilter && !action.options.ignoreKeyword) params.keyword = reviewsKeywordFilter;
      if (resourcesOnly) params.resourcesOnly = resourcesOnly;

      if (ignoreResources) {
        params.ignoreResources = ignoreResources;
        params.skip -= forcedResourceCount;
      }

      yield put(setReviewsLoaded(false));
      const result = yield call(() => webApi.reviews.getUnreviewedResources(params));

      yield put(loadReviewsPartialResult(result));

      if (resourcesOnly) {
        yield put(setForcedResourceCount(result.length));
        return yield put(getMoreReviews({
          ignoreResources: resourcesOnly,
          limit: reviewsToShow - result.length,
        }));
      }

      yield put(setReviewsLoaded(true));
      if (result.length <= 0 || result.length < params.limit) yield put(setReviewsAllLoaded(true));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in get more reviews saga', ex);
    }
  }

  function* getNumOfCommentedReviewsSaga() {
    try {
      const numOfCommentedReviews = yield call(() => webApi.reviews.getNumOfCommentedReviews());
      yield put(setNumOfCommentedReviews(numOfCommentedReviews.count));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in get number of commented reviews saga', ex);
    }
  }

  function* getReviewReasonsSaga() {
    try {
      const { reviewReasons } = yield call(() => webApi.reviews.getReviewReasons());
      yield put(setReviewReasons(reviewReasons));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in get review reasons', ex);
    }
  }

  return {
    * watchGetMoreReviews() { yield* takeLatest(GET_MORE_REVIEWS, getMoreReviewsSaga); },
    * watchSubmitReview() { yield* takeLatest(SUBMIT_REVIEW, submitReviewsSaga); },
    * watchGetNumOfCommentedReviewsSaga() { yield* takeLatest(GET_NUM_OF_COMMENTED_REVIEWS, getNumOfCommentedReviewsSaga); },
    * watchGetReviewReasonsSaga() { yield* takeLatest(GET_REVIEW_REASONS, getReviewReasonsSaga); },
  };
}
